//noScroll
class FormConvert {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    //全角から半角
    function replaceZtoH(str){
      str = str.replace(/[！-～]/g, function(s){
        return String.fromCharCode(s.charCodeAt(0) - 0xFEE0);
      });
      str = str.replace(/[-－﹣−‐⁃‑‒–—﹘―⎯⏤ーｰ─━]/g, '-');
      return str;
    }
    const el = document.querySelector('[name="電話番号"]');
    el.addEventListener('blur', () => {
      const br = el.value;
      const ar = replaceZtoH(br);
      console.log(ar);
      el.value = ar;
    });
  }
}

// フッターのブランドリストスライダー
$(function () {
  const mvSwiper = new Swiper('.js-brand-swiper', {
    slidesPerView: 3,
    spaceBetween: 9,
    loop: false,
    breakpoints: {
      768: {
        slidesPerView: 'auto',
        spaceBetween: 10,
        centerdSlides: true
      }
    },
    on: {
      init: function () {
        updateProgressBar(this.progress);
      },
      slideChange: function () {
        updateProgressBar(this.progress);
      },
    },
  })
  function updateProgressBar(progress) {
    var progressBar = document.querySelector('.js-brand-swiper-progressbar .in-bar');
    progressBar.style.width = progress * 100 + '%';
  }
})

// 目次自動変更
$(function () {
  const tocList = '.js-toc-nav';
  const tocSection = '.js-toc-section';
  const headerEle = '.js-header'
  const headerHeight = $(headerEle).height();
  // console.log(headerHeight)

  let isScrolling = false;

  $(tocSection).each(function (index, element) {
    ScrollTrigger.create({
      trigger: element, // この要素をトリガーとする
      start: 'top 200',
      end: 'bottom 200',
      onEnter: () => !isScrolling && toggleTocList(element),
      onEnterBack: () => !isScrolling && toggleTocList(element)
    });
  });
  function toggleTocList(element) {
    const thisId = $(element).attr('id');
    $(tocList).find('.is-active').removeClass('is-active');
    $(tocList).find(`[href="#${thisId}"]`).addClass('is-active');
    if (window.matchMedia && window.matchMedia('(max-width: 768px)').matches) {
      const activeElement = $(tocList).find('.is-active');
      const tocListOffsetLeft = $(tocList).offset().left;
      const activeElementOffsetLeft = activeElement.offset().left;
      const activeScrollX = activeElementOffsetLeft - tocListOffsetLeft + $(tocList).scrollLeft() - 20;

      gsap.to(tocList, {
        scrollLeft: activeScrollX
      });
    }
  }
  $(window).scroll(function () {
    const scrollPosition = $(window).scrollTop();
    if (window.matchMedia && window.matchMedia('(max-device-width: 768px)').matches) {
      if (scrollPosition > headerHeight + 200) {
        const thisHeaderHeight = $('[x-ref=spScrolledNav]').height();
        // const adjustHeaderHeight = $('[x-ref=spScrolledNav]').height() + $('[x-ref=spCatNav]').height();
        gsap.to(tocList, {
          top: thisHeaderHeight
        })
      } else {
        gsap.to(tocList, {
          top: 0
        })
      }
    }
  })
  // 目次のリンクがクリックされたときの動作
  $('.js-toc-anker').on('click', function (e) {
    e.preventDefault(); // デフォルトの動作を停止
    isScrolling = true

    var targetId = $(this).attr('href');
    var targetPosition = $(targetId).offset().top - headerHeight; // ヘッダーの高さを考慮したスクロール位置を計算

    $('html, body').animate({ scrollTop: targetPosition }, 300, 'swing', function () {
      // スクロール完了後のコールバック（必要に応じて）
      isScrolling = false
    });
  });
})
class AjaxPosts {
  constructor(el, opt) {
    this.el = el;
  }

  getParam(name, url) {
    if (!url) url = window.location.href;
    name = name.replace(/[\[\]]/g, "\\$&");
    var regex = new RegExp("[?&]" + name + "(=([^&#]*)|&|#|$)"),
      results = regex.exec(url);
    if (!results) return null;
    if (!results[2]) return '';
    return decodeURIComponent(results[2].replace(/\+/g, " "));
  }

  postChange(postType, postsPerPage) {
    const targetElement = '.js-ajax-posts';
    const thisUrl = new URL(location.href);
    const pCat = this.getParam('p-cat', thisUrl);
    const pDate = this.getParam('p-date', thisUrl);
    const startDate = this.getParam('start-date', thisUrl);
    const endtDate = this.getParam('end-date', thisUrl);
    const paged = this.getParam('paged', thisUrl);
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        'action': 'fetch_posts',
        'post_type': postType,
        'posts_per_page': postsPerPage,
        'p_cat': pCat,
        'p_date': pDate,
        'start_date': startDate,
        'end_date': endtDate,
        'paged': paged
      },
    })
      .done(function (data) {

        $(targetElement).html(data)

      })
      .fail(function () {

      });
  }

  paginationChange(postType, postsPerPage) {
    const targetElement = '.js-ajax-pagination';
    const thisUrl = new URL(location.href);
    const pCat = this.getParam('p-cat', thisUrl);
    const pDate = this.getParam('p-date', thisUrl);
    const paged = this.getParam('paged', thisUrl);
    const startDate = this.getParam('start-date', thisUrl);
    const endtDate = this.getParam('end-date', thisUrl);
    $.ajax({
      url: ajaxurl,
      type: 'POST',
      data: {
        'action': 'fetch_pagination',
        'post_type': postType,
        'posts_per_page': postsPerPage,
        'p_cat': pCat,
        'p_date': pDate,
        'this_url': thisUrl.href,
        'paged': paged,
        'start_date': startDate,
        'end_date': endtDate,
      },
    })
      .done(function (data) {

        $(targetElement).html(data);

        const targetWrap = document.getElementById('ajax-posts-wrap');
        if (targetWrap) {
          targetWrap.scrollIntoView({ behavior: 'smooth' }); // スムーズスクロール
        }
      })
      .fail(function (data) {
        console.log(data.responseText)
      });
  }

  doPagination(element, postType, postsNum) {

    const thisUrl = new URL(location.href);
    const paged = 'paged=' + element.dataset.paged;
    const thisPaged = this.getParam('paged', thisUrl);
    if (thisPaged) {
      // thisUrlがURLオブジェクトであると仮定
      const params = new URLSearchParams(thisUrl.search);
      // パラメータを更新
      params.set('paged', element.dataset.paged);
      // 更新したクエリ文字列をURLに再設定
      thisUrl.search = params.toString();
      history.pushState('記事検索', '検索', thisUrl.href);
    }
    else if (thisUrl.search) {
      history.pushState('記事検索', '検索', thisUrl.href + '&' + paged);
    } else {
      history.pushState('記事検索', '検索', thisUrl.href + '?' + paged);
    }

    this.postChange(postType, postsNum);
    this.paginationChange(postType, postsNum);
  }
}
var CFL = {
  UA: {
    raw: function raw() {
      return navigator.userAgent;
    },
    is: function is(_is) {
      var ua = CFL.UA.raw();
      if (_is === 'issp') {
        return CFL.UA.isSp();
      }
    },
    isSp: function isSp() {
      var ua = CFL.UA.raw();
      return ua.indexOf('iPhone') > 0 || ua.indexOf('iPod') > 0 || ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0;
    },
    isTablet: function() {
      var ua = CFL.UA.raw();
      if(ua.indexOf('Android') > 0 && ua.indexOf('Mobile') > 0) {
      } else if (ua.indexOf('iPad') > -1
         || (ua.indexOf('Macintosh') > -1 && CFL.UA.Device.isTouch() )
         || ua.indexOf('Android') > 0) {
        return true;
      }

      return false;
    },
    isEdge: function() {
      return this.raw().indexOf('Edge') != -1;
    },
    isIE: function() {
      var ua = CFL.UA.raw();
      return this.raw().indexOf('Trident') != -1 ;
    }
  },
  Device: {
    isTouch: function() {
      return 'ontouchend' in document;
    }
  }
};

var isMobile = function () {
  return (window.matchMedia('(max-width: '+ APP.bp.mobile +'px)').matches)
}

var isPortrait = function() {
  let defaultOrientation = null;
  if('orientation' in window) {
    var o1 = (window.innerWidth < window.innerHeight);
    var o2 = (window.orientation % 180 == 0);
    defaultOrientation = (o1 && o2) || !(o1 || o2);
  }
  if('orientation' in window) {
    // defaultOrientationがtrueの場合、window.orientationが0か180の時は縦
    // defaultOrientationがfalseの場合、window.orientationが-90か90の時は横
    var o = (window.orientation % 180 == 0);
    if((o && defaultOrientation) || !(o || defaultOrientation)) {
      return true;
    } else {
      return false;
    }
  }
}
// 参考サイト
// https://hacknote.jp/archives/15289/

var cookie = {
	/**
	 * 取得
	 * @param {string} cookieName 取得するCookieの名前
	 */
	get : function(cookieName) {
		if (!navigator.cookieEnabled) return false;

		var getCookieAllData  = document.cookie,
		    getCookieAllDatas = getCookieAllData.split(';'),
		    getCookieDatas    = {},
		    cookieKeyValue    = [],
		    cookieKey         = '',
		    cookieValue       = '';

		var hashLength = function(arr) {
			var result = 0, key = false;

			if (typeof arr !== 'object') return false;

			for (key in arr) result++;

			return result;
		};

		for (var i = 0, len = getCookieAllDatas.length; i < len; i++) {
			if (getCookieAllDatas[i] && getCookieAllDatas[i] !== '') {
				cookieKeyValue = getCookieAllDatas[i].split('=');
				cookieKey      = cookieKeyValue[0].replace(/^\s+/, '');
				cookieValue    = '';

				if (cookieKeyValue[1]) {
					cookieValue = decodeURIComponent(cookieKeyValue[1]);
				}

				getCookieDatas[cookieKey] = cookieValue;
			}
		}

		if (hashLength(getCookieDatas) > 0) {
			if (cookieName && cookieName in getCookieDatas) {
				return getCookieDatas[cookieName];
			} else {
				return getCookieDatas;
			}
		} else {
			return '';
		}
	},

	/**
	 * 設定
	 * @param {string} cookieName 設定するCookieの名前
	 * @param {string} value 設定する値
	 * @param {string} domain 有効ドメイン
	 * @param {string} path 有効パス
	 * @param {string} expires 有効期限
	 * @param {boolean} secure セキュアとするか
	 * @return {boolean} 設定に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	set : function(cookieName, value, domain, path, expires, secure) {
		if (!navigator.cookieEnabled || !cookieName || !value) return false;

		var date, dt, ts, ts_after;

		var setCookieData = cookieName + '=' + encodeURIComponent(value) + ';';

		if (domain) setCookieData += 'domain=' + domain + ';';

		if (path) setCookieData += 'path=' + path + ';';

		if (expires) {
      dt = new Date();
      ts = dt.getTime();

      // 1時間後
      ts_after = ts + (1000 * 60 * 60 * expires);

      date = new Date(ts_after);
			setCookieData += 'expires=' + date.toGMTString() + ';';
		}

		if (secure && secure === true && location.protocol.match(/https/)) {
			setCookieData += 'secure';
		}

		document.cookie = setCookieData;

		return true;
	},

	/**
	 * 削除
	 * @param {string} cookieName 削除するCookieの名前
	 * @return {boolean} 削除に成功した場合はtrue、失敗した場合はfalseを返す
	 */
	del : function(cookieName) {
		if (!navigator.cookieEnabled || !cookieName) return false;

		var getCookieDatas = this.get();

		if (getCookieDatas[cookieName]) {
			var setCookieData = cookieName + '=;',
			    date          = new Date(0);

			setCookieData += 'expires=' + date.toGMTString() + '';

			document.cookie = setCookieData;

			return true;
		}

		return false;
	}
};
class FixedFilter {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.initAnimation();
      this.event();
    }
  }

  initAnimation() {
    // GSAPアニメーションの初期設定
    this.gsapTimeline = gsap.timeline({ paused: true });
    this.gsapTimeline.to("." + this.el, { duration: 0.5, bottom: "1rem" });
  }

  event() {
    let lastScroll = 0;

    window.addEventListener('scroll', () => {
      const currentScroll = window.pageYOffset;

      if (currentScroll <= lastScroll) {
        // 上にスクロールしている場合、またはスクロールが停止している場合
        this.gsapTimeline.play();
      } else {
        // 下にスクロールしている場合
        this.gsapTimeline.reverse();
      }

      lastScroll = currentScroll <= 0 ? 0 : currentScroll; // スクロール位置を更新

      // スクロールが停止したことを検出
      clearTimeout(window.scrollFinished);
      window.scrollFinished = setTimeout(() => {
        this.gsapTimeline.play();
      }, 100);
    });
  }
}
//noScroll
class ImgParallax {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.event();
    }
  }
  event(){
    this.para_ele = document.querySelectorAll("." + this.el);
    this.para_ele.forEach((ele, index)=> {
      if(ele.classList.contains('js-parallax--reverse')) {
        this.translateY = '20px';
      } else {
        this.translateY = '-20px';
      }
      ele.classList.add(this.el + index);
      gsap.to('.' + this.el + index + ' img', {
        translateY: this.translateY,
        scrollTrigger: {
          trigger: '.' + this.el + index, // 要素がビューポートに入ったときにアニメーション開始
          start: 'top bottom',
          scrub: 3,
        }
      })
    })
  }
}

class InviewEvent {
  constructor(el, opt){
    this.el = el;
    this.all = this.el + '-all';
    this.eachUp = this.el + '-each';
    this.eachItem = this.el + '-eachItem';
    this.eachItemFast = this.el + '-eachItem-fast';
    this.eachItemDelay = this.el + '-eachItem-delay';
    if($(this.el).length > 0){
      this.event();
    }
  }
  event() {
    let options = {
      threshold: [0, 0.05, 0.1, 1]
    }
    let optionsAll = {
      threshold: [0, 0.9, 1]
    }
    const observerEnter = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.05){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          if(item.classList.contains('js-inview-lottie')){
            this.inviewLottie(item);
          }
          observerEnter.unobserve(item);
        }
      });
    }, options);
    const observerAll = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        const item = entry.target;
        if(entry.intersectionRatio >= 0.9){
          item.classList.add('is-inview');
          if(item.classList.contains('js-inview-each')){
            this.inviewEachUp(item);
          }
          observerAll.unobserve(item);
        } else {
          item.classList.remove('is-inview');
        }
      });
    }, optionsAll);
    const inviewItem = document.querySelectorAll(this.el);
    const inviewAllItem = document.querySelectorAll(this.all);
    inviewItem.forEach((e)=>{
      observerEnter.observe(e);
    });
    inviewAllItem.forEach((e)=>{
      observerAll.observe(e);
    });
  }
  inviewEachUp(item){
    $(item).find(this.eachItem).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.2 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemFast).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.1 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
    $(item).find(this.eachItemDelay).each((i,el)=>{
      gsap.to($(el), {
        // duration: 0.8,
        // alpha: 1,
        delay: (0.5 * i),
        // y: 0,
        // x: 0,
        onComplete: ()=>{
          $(el).addClass('is-inview');
        }
      });
    });
  }
  inviewLottie(item){
    if($(item).hasClass('js-lottie-flow')) {
      lottie.flow();
    }
    if($(item).hasClass('js-lottie-no01')) {
      lottie.no01();
    }
    if($(item).hasClass('js-lottie-no02')) {
      lottie.no02();
    }
    if($(item).hasClass('js-lottie-no03')) {
      lottie.no03();
    }
    if($(item).hasClass('js-lottie-no04')) {
      lottie.no04();
    }
    if($(item).hasClass('js-lottie-no05')) {
      lottie.no05();
    }
    if($(item).hasClass('js-lottie-no06')) {
      lottie.no06();
    }
    if($(item).hasClass('js-lottie-no07')) {
      lottie.no07();
    }
  }
}

class JoliToc {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const toc = '.wpj-jtoc';
    const tocWrap = '.wpj-jtoc--toc';
    const openH = $(tocWrap).outerHeight();
    const tocToggle = '.wpj-jtoc--toggle-icon';
    $(tocToggle).append('<div class="js-add-cross"></div>');
    $(tocToggle).on('click', function () {
      if ($(toc).hasClass('is-active')) {
        $(toc).css('max-height', '');
      } else {
        $(toc).css('max-height', openH);
      }
      $(toc).toggleClass('is-active');
    })
  }
}
class Loading {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const loadElement = '.' + this.el;
    // $(loadElement).addClass('is-load');
    // $('.js-loading-anime').fadeOut();
  }
}
class MuuriGrid {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const muuriGrid = '.' + this.el;
    var grid = new Muuri(muuriGrid, {
      layout: {
        fillGaps: true,
      }
    });
    setTimeout(() => {
      $('.js-loading-anime').fadeOut(300);
      $('.js-muuri-grid, .js-paging').animate({'opacity': '1'});
  }, 200);
  }
}
class RecoomendCatList {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const listWrap = document.querySelector('.' + this.el);
    const listInner = document.querySelector('.' + this.el + '__inner');
    const listWrapWidth = listWrap.clientWidth;
    const listPlus = document.querySelector('.' + this.el + '__plus');
    const listNodeList = listWrap.querySelectorAll('a');
    let listInnerTotalWidth = 0;
    const rem = window.innerWidth / 1400 * 10;
    const listInnerTotalGap = ((listNodeList.length - 1) * rem);
    listNodeList.forEach((list) => {
      listInnerTotalWidth += list.clientWidth;
    })
    listInnerTotalWidth += listInnerTotalGap;
    // console.log(listWrapWidth)
    // console.log(listInnerTotalWidth)
    if (listWrapWidth < listInnerTotalWidth) {
      listPlus.style.opacity = '1';
    }

    // スクロールした時の挙動
    let listInnerScroll = 0;
    listInner.addEventListener('scroll', (event) => {
      listInnerScroll = listInner.scrollLeft;
      if (listInnerTotalWidth < (listWrapWidth + listInnerScroll)) {
        listPlus.style.opacity = '0'
      } else {
        // listPlus.style.opacity = '1'
      }
    })
  }
}
class RelatedSwiper {
  constructor(el, opt) {
    this.el = el;
    if ($("." + this.el).length > 0) {
      this.event();
    }
  }

  event() {
    const relatedSwiper = "." + this.el;
    const swiper = new Swiper(relatedSwiper, {
      slidesPerView: 2,
      spaceBetween: 8,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 8,
          slidesPerGroup: 4,
        },
      },
      navigation: {
        nextEl: ".js-related-swiper-next",
        prevEl: ".js-related-swiper-prev",
      },
    })
  }
}
// -------------------------------------------------
// スクロール禁止
// -------------------------------------------------
let scrollTop = 0;

function scrollBan() {
  const body = $('html')[0];
  if (body.classList.contains('is-hidden')) {
    // スクロール開放
    body.style.top = '';
    body.classList.remove('is-hidden');
    window.scrollTo(0, scrollTop);
  } else {
    // スクロール禁止
    scrollTop = window.scrollY;
    body.style.top = (scrollTop * -1) + 'px';
    body.classList.add('is-hidden');
  }
}


(() => {
})();

//DOMContentLoaded
$(() => {
});

//images resources loaded
$(window).on('load', () => {
  $(window).trigger('loading');
});

//after loading animation
$(window).on('loading', () => {
  let loading = new Loading('js-loading-inner');
  let imgParallax = new ImgParallax('js-parallax');
  let inviewEvent = new InviewEvent('.js-inview');
  let formConvert = new FormConvert('js-convert');
  let fixedFilter = new FixedFilter('js-fixed-filter');
  let joliToc = new JoliToc('wpj-jtoc');
  let relatedSwiper = new RelatedSwiper('js-related-swiper');
  let muuriGrid = new MuuriGrid('js-muuri-grid');
  let recoomendCatList = new RecoomendCatList('js-recommend-cat-list');
  window.ajaxPosts = new AjaxPosts();
});

// スマホ・タブレットの向き判定
// $(window).on('orientationchange', ()=>{
//   if(isPortrait()){
//     console.log('isPortrait');
//   } else {
//     console.log('isLandscape');
//   }
// });